import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { configUserLogin } from 'utils/googleAnalytics';
import { dispatchHotjarIdentity } from 'utils/hotjar';

import { selectUserId } from 'reduxLocal/slices/authSlice';

import { useRedirectTo } from 'hooks/useRedirectTo';

import { LoggingIn } from 'components/ui/organisms/LoggingIn';

export const LoginTransition = () => {
  const { navigateOrRedirectTo } = useRedirectTo();
  const { organisationId } = useParams(); // Don't change this to useOrganisationId it will cause the cypress tests to fail
  const userId = useSelector(selectUserId);

  useEffect(() => {
    if (userId) {
      configUserLogin(String(userId));
      dispatchHotjarIdentity(String(userId));
    }
    navigateOrRedirectTo(`/org/${organisationId}`);
  }, [navigateOrRedirectTo, organisationId, userId]);

  return <LoggingIn />;
};
